import { Component, Input, OnChanges } from '@angular/core';

type MetricFormat = 'money' | 'percent' | 'balance' | 'empty';


@Component({
  selector: 'app-result-place-maye-preview',
  templateUrl: './result-place-maye-preview.component.html',
  styleUrls: ['./result-place-maye-preview.component.scss']
})
export class ResultPlaceMayePreviewComponent implements OnChanges {
  @Input() data: any = null;

  metrics = [
    { key: 'totalSale', label: 'Ventas', format: 'money' },
    { key: 'totalCost', label: 'Costos de Venta', format: 'money' },
    { key: 'grossProfit', label: 'Utilidad Bruta', format: 'money' },
    { key: 'totalExpense', label: 'Gasto Destino', format: 'money' },
    { key: 'totalExpenseNotAssociated', label: 'Gasto sin Destino', format: 'money' },
    { key: 'profit', label: 'Utilidad', format: 'money' },

    { separator: true },
    { separator: true },

    { key: 'salePercentage', label: 'Porcentaje de Venta', format: 'percent' },
    { key: 'grossMargin', label: 'Margen Bruto', format: 'percent' },
    { key: 'destinationExpense', label: 'Gasto Destino', format: 'percent' },
    { key: 'destinationExpenseNotAssociated', label: 'Gastos sin Destino', format: 'percent' },
    { key: 'netMargin', label: 'Margen Neto', format: 'percent' },
    { key: 'profitPercentage', label: 'Porcentaje de Utilidad', format: 'percent' },

    { separator: true },

    { key: 'title', label: 'Cuentas por Cobrar' },
    { key: 'totalBeginningBalancePlace', label: 'Saldos Iniciales', format: 'balance' },
    { key: 'totalSalesPlace', label: 'Ventas', format: 'balance' },
    { key: 'totalPaymentsPlace', label: 'Cobros', format: 'balance' },
    { key: 'totalEndingBalancePlace', label: 'Saldos Finales', format: 'balance' }

  ];

  columns: any[] = [];

  ngOnChanges(changes: any) {
    if (changes.data) {
      this.buildColumns(this.data);
    }
  }

  onDataChange(current: any, previous: any) {
    console.log('Data cambió', { current, previous });
    // tu lógica aquí
  }

  buildColumns(data: any) {
    this.columns = [];

    data.resultPlaces.forEach(place => {

      // columnas por destinos
      place.resultDestinations.forEach(dest => {
        this.columns.push({
          type: 'destination',
          header: dest.destinationName,
          data: dest
        });
      });

      // columna total del place (siempre al final)
      this.columns.push({
        type: 'place-total',
        header: `TOTAL ${place.placeName}`,
        data: place
      });

    });

    this.columns.push(
      { type: 'separator' },
      { type: 'separator' }
    );

    // columna total general (siempre al final)
    this.columns.push({
      type: 'grand-total',
      header: 'TOTAL GENERAL',
      data: data
    });
  }

  getCellValue(metric: any, col: any): number | null {
    if (col.type === 'separator') return null;

    if (metric.format === 'balance') {
      return col.type === 'place-total'
        ? col.data?.balances?.[metric.key] ?? null
        : null;
    }

    if ((metric.key === 'salePercentage' || metric.key === 'profitPercentage') && col.type === 'destination') {
      return null
    }

    return col.data?.[metric.key] ?? null;
  }

  getFormat(metric: any): string {
    switch (metric.format) {
      case 'percent':
        return '1.2-4';
      default:
        return '1.2-2';
    }
  }
}
